<template lang="pug">
.general
  .entity-content.pa-5
    v-row
      v-col.d-flex.align-center
        h2.primary--text {{ $t('Chart.generalInfo') }}
    v-row
      v-col
        v-text-field(
          :label="$t('Chart.name')",
          v-model="instance.name",
          :error-messages="errors['chart.name']",
        )
      v-col
        v-text-field(
          :label="$t('Chart.dimensionsHeader')",
          v-model="instance.dimensionsHeader",
          :error-messages="errors['chart.dimensionsHeader']",
        )
      v-col
        //- v-model="instance.statusId",
        v-select(
          v-bind="{ value }",
          :label="$t('Chart.type')",
          :items="chartTypes",
          @input="$emit('input', $event)",
        )
      v-col
        v-select(
          :label="$t('Chart.entity')",
          :value="getEntityName(instance)",
          :items="sortedEntityList",
          item-text="name",
          return-object,
          @input="selectEntity",
          :error-messages="errors['chart.entity']",
        )
    v-row
      v-col
        app-datetime-picker(
          :value="instance.createdAt",
          :label="$t('Chart.createdAt')",
          disabled,
        )
      v-col
        app-datetime-picker(
          :value="instance.modifiedAt",
          :label="$t('Chart.modifiedAt')",
          disabled,
        )
      v-col
        v-text-field(
          :value="instance.createdBy",
          :label="$t('Chart.userFullName')",
          disabled,
        )
  template(v-for="section in (slotProps.sections || []).filter(x => x.section === slotProps.entity.name || x.section === slotProps.entity.tabLabel)")
    app-entity-relation(:path="section.name", :parent="slotProps.entity", :parent-instance="instance", :relation="section", :entity="$findEntity(section.type)")
  setup-options(
    :value="config",
    v-bind="{ baseOptions, options }",
    @input="$emit('update:config', $event)",
  )
  chart-preview(:chartType="value", v-bind="{ config }")
</template>

<script>
import EntityMixin from '@/mixins';
import SetupOptions from '@/components/Chart/SetupOptions';
import ChartPreview from '@/components/Chart/ChartPreview';

import  AreaChart from '@/components/ChartTypes/AreaChart';
import  BarChart from '@/components/ChartTypes/BarChart';
import  BubbleChart from '@/components/ChartTypes/BubbleChart';
import  ColumnChart from '@/components/ChartTypes/ColumnChart';
import  ComboChart from '@/components/ChartTypes/ComboChart';
import  Gauge from '@/components/ChartTypes/Gauge';
import  Histogram from '@/components/ChartTypes/Histogram';
import  LineChart from '@/components/ChartTypes/LineChart';
import  PieChart from '@/components/ChartTypes/PieChart';
import  Table from '@/components/ChartTypes/Table';

export default {
  mixins: [EntityMixin],
  props: {
    slotProps: null,
    loading: null,
    errors: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: String,
    },
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    SetupOptions,
    ChartPreview,
  },
  data: () => ({
    orderStatuses: [],
    statusLoading: true,
    chartTypes: [
      'AreaChart',
      'BarChart',
      'BubbleChart',
      'ColumnChart',
      'ComboChart',
      'Gauge',
      'Histogram',
      'LineChart',
      'PieChart',
      'Table',
    ],

    configs: {
      AreaChart,
      BarChart,
      BubbleChart,
      ColumnChart,
      ComboChart,
      Gauge,
      Histogram,
      LineChart,
      PieChart,
      Table,
    },
  }),
  computed: {
    entityList() {
      return [...this.$store.state.schema.all, { name: 'Pending Tasks', customEntity: 'Responsibility' }];
    },
    sortedEntityList() {
      return (this.entityList || []).sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });
    },
    baseOptions() {
      if (!this.value) return null;
      return this.configs[this.value].baseOptions;
    },
    options() {
      if (!this.value) return null;
      return this.configs[this.value].options;
    },
  },
  methods: {
    getEntityName({ customEntity, entity }) {
      return customEntity || entity;
    },
    async selectEntity ({ name, customEntity }) {
      this.instance.entity = customEntity || name;
      if (customEntity) this.instance.customEntity = name;
      this.$store.commit('SET_CRITERIA_ENTITY_NAME', customEntity || name);
    },
  },
  async created() {
  },
}
</script>
